import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import ClearingHouseCreateTab from './ClearingHouseCreateTab';
import { clearingHousePropertiesType } from '../../types';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';

CreateClearingHouseRow.propTypes = {
    clearingHouseProps: clearingHousePropertiesType.isRequired,
};

function CreateClearingHouseRow(props) {
    const {
        clearingHouseProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-clearing-house-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('clearing-houses.create-clearing-house')}</CreateButton>
            {isCreateVisible && (
                <ClearingHouseCreateTab
                    hideHandler={() => setCreateVisible(false)}
                    clearingHouseProps={clearingHouseProps}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.CLEARING_HOUSE_EDIT])(CreateClearingHouseRow);
